module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/language.svg?e489e3514da263877f9af99170491ddf";